// Réalisations ATLAS THD — données éditoriales.
// Pour ajouter une réalisation : ajouter un objet dans REALISATIONS.
// Les filtres de la page s'activent automatiquement dès qu'une catégorie
// contient au moins une réalisation. Ne jamais créer de réalisation fictive.
//
// Champs :
// - id : identifiant unique (kebab-case)
// - titre : titre descriptif du chantier ou de la mission
// - categories : un ou plusieurs identifiants de CATEGORIES ci-dessous
// - description : description technique courte
// - image : chemin ou URL de la photographie réelle fournie par ATLAS THD
// - alt : texte alternatif descriptif (sans bourrage de mots-clés)
// - localisation : uniquement si confirmée et publiable (sinon null)
// - date : uniquement si connue et autorisée (sinon null)

export const CATEGORIES = [
  { id: "ftto", label: "Raccordements FTTO" },
  { id: "ftth", label: "Raccordements FTTH" },
  { id: "interventions", label: "Interventions terrain" },
  { id: "inspection", label: "Inspection technique" },
  { id: "conformite", label: "Contrôle de conformité" },
  { id: "audit-vqse", label: "Audit qualité et VQSE" },
];

export const REALISATIONS = [
  {
    id: "pm-coueron",
    titre: "Point de mutualisation — Couëron",
    categories: ["ftth", "conformite", "audit-vqse"],
    description:
      "Intervention sur un point de mutualisation (PM) en armoire de rue : organisation, brassage et repérage des câblages optiques.",
    image: "/realisations/pm-coueron.webp",
    alt: "Armoire de point de mutualisation ouverte avec câblage fibre optique organisé à Couëron",
    localisation: "Couëron (Loire-Atlantique)",
    date: "Août 2024",
  },
  {
    id: "pm-treillieres",
    titre: "Point de mutualisation — Treillières",
    categories: ["ftth", "conformite", "audit-vqse"],
    description:
      "Travaux sur les plateaux d'épissurage et les coupleurs optiques d'un point de mutualisation : rangement des fibres et continuité du câblage.",
    image: "/realisations/pm-treillieres.webp",
    alt: "Plateaux d'épissurage et coupleurs optiques dans un point de mutualisation à Treillières",
    localisation: "Treillières (Loire-Atlantique)",
    date: "Septembre 2024",
  },
];
